import { render } from "./PolicyDetailsview.vue?vue&type=template&id=3189b3f4&scoped=true"
import script from "./PolicyDetailsview.vue?vue&type=script&lang=js"
export * from "./PolicyDetailsview.vue?vue&type=script&lang=js"

import "./PolicyDetailsview.vue?vue&type=style&index=0&id=3189b3f4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3189b3f4"]])

export default __exports__